import AbstractDeviceSetup from "../all/AbstractDeviceSetup";

class ZeasnDeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }
}

export default ZeasnDeviceSetup;


// WEBPACK FOOTER //
// ./src/devices/zeasn/DeviceSetup.js